const $ = jQuery.noConflict();

$(document).ready(function () {
  let grecaptchaReady = false;
  let generateGrecaptchaToken = function (callback) {
    grecaptcha.execute('6LcUrnQdAAAAAHoXBg-UQ2vjXRD1K7tDcICh5QVN', {action: 'validate_captcha'}).then(function (token) {
      if (token) {
        document.getElementById('g-recaptcha-response').value = token;

        if (typeof callback === 'function') {
          callback();
        }
      }
    });
  };

  if (grecaptcha) {
    grecaptcha.ready(function () {
      grecaptchaReady = true;
      $('.grecaptcha-badge').attr('aria-label', 'Google reCAPTCHA form protection badge');
      generateGrecaptchaToken();
    });
  }

  $('.email__signup').on('submit', function (e) {
    e.preventDefault();

    let $email = $('input#control_EMAIL');
    let $firstName = $('input#control_FIRSTNAME');
    let $lastName = $('input#control_LASTNAME');
    let $zipcode = $('input#control_ZipCode');
    let $form = $('.email__signup');
    let error = false;
    let errormsg = '';

    $('.email__form-success-msg').hide();

    //reset
    $email.removeClass('error');
    $firstName.removeClass('error');
    $lastName.removeClass('error');
    $zipcode.removeClass('error');

    //validate email
    if (!isEmail($email.val())) {
      $email.addClass('error');
      errormsg += '<span class="email__form-error-icon"></span> Enter a valid email<br/>';
      error = true;
    }

    //validate first name
    if (!isName($firstName.val())) {
      $firstName.addClass('error');
      errormsg += '<span class="email__form-error-icon"></span> Enter a valid first name<br/>';
      error = true;
    }

    //validate last name
    if (!isName($lastName.val())) {
      $lastName.addClass('error');
      errormsg += '<span class="email__form-error-icon"></span> Enter a valid last name<br/>';
      error = true;
    }

    //validate zipcode
    if (!isZipcode($zipcode.val())) {
      $zipcode.addClass('error');
      errormsg += '<span class="email__form-error-icon"></span> Enter a valid zipcode<br/>';
      error = true;
    }

    //if there is an error
    if (error) {
      $('.email__form-error-msg').html(errormsg.substring(0, errormsg.length - 5));
      $('.email__form-error-msg').show();

      //no error in the form
    } else {
      if (grecaptchaReady) {
        generateGrecaptchaToken(function () {
          $('.email__form-error-msg').hide();
          $('.email__input-loading').addClass('show');

          const formData = decodeURIComponent($form.serialize());

          $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            dataType: 'json',
            data: formData,
            success: function (result) {
              if (result.success) {
                $('.email__form-success-msg').show();
                $('.email__signup input[type="text"]').val('');
                $('.email__signup input[type="text"]').removeClass('checked');
              } else {
                $('.email__form-error-msg').html('<span class="email__form-error-icon"></span> ' + result.msg);
                $('.email__form-error-msg').show();
              }

              $('.email__input-loading').removeClass('show');
            }
          });
        });
      }
    }

    return false;
  });

  $('.email__signup input#control_EMAIL').on('keyup', function () {
    let $emailField = $(this);

    $emailField.removeClass('error');

    if (isEmail($emailField.val())) {
      $emailField.addClass('checked');
    } else {
      $emailField.removeClass('checked');
    }
  });

  $('.email__signup input#control_FIRSTNAME, .email__signup input#control_LASTNAME').on('keyup', function () {
    let $firstNameField = $(this);

    $firstNameField.removeClass('error');

    if (isName($firstNameField.val())) {
      $firstNameField.addClass('checked');
    } else {
      $firstNameField.removeClass('checked');
    }
  });

  $('.email__signup input#control_LASTNAME').on('keyup', function () {
    let $lastNameField = $(this);

    $lastNameField.removeClass('error');

    if (isName($lastNameField.val())) {
      $lastNameField.addClass('checked');
    } else {
      $lastNameField.removeClass('checked');
    }
  });

  $('.email__signup input#control_ZipCode').on('keyup', function () {
    let $zipCodeField = $(this);

    $zipCodeField.removeClass('error');

    if (isZipcode($zipCodeField.val())) {
      $zipCodeField.addClass('checked');
    } else {
      $zipCodeField.removeClass('checked');
    }
  });
});

//validate email
function isEmail (email) {
  let regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

//validate name
function isName (name) {
  let regex = /^.+$/;
  return regex.test(name);
}

//validate zipcode
function isZipcode (zipcode) {
  let regex = /^.{5,}$/;
  return regex.test(zipcode);
}
